import { render, staticRenderFns } from "./rule12.vue?vue&type=template&id=331e34f0&scoped=true"
import script from "./rule12.vue?vue&type=script&lang=js"
export * from "./rule12.vue?vue&type=script&lang=js"
import style0 from "./rule12.vue?vue&type=style&index=0&id=331e34f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331e34f0",
  null
  
)

export default component.exports